import { Component, OnDestroy, OnInit } from '@angular/core'
import { collection, doc, DocumentData, Firestore, getDocs, orderBy, query, QuerySnapshot } from '@angular/fire/firestore'
import { ActivatedRoute } from '@angular/router'
import { of, throwError } from 'rxjs'
import { mergeMap } from 'rxjs/operators'
import { DocumentEntry, documentTypesArray } from 'src/domain/document'
import { DocumentEntryItem } from '../components/documents/documents.component'

@Component({
    templateUrl: './dog-documents.component.html',
    styleUrls: ['./dog-documents.component.scss'],
    standalone: false
})
export class DogDocumentsComponent implements OnInit, OnDestroy {
  constructor(private route: ActivatedRoute, private store: Firestore) {}

  dogId!: string
  dogName = ''

  allDocuments: DocumentEntryItem[] = []
  // we don't allow new MATESZE docs to be uploaded but need to list older one
  dogDocumenTypes = documentTypesArray.filter(v => !v.key.startsWith("MATESZE"))

  ngOnInit(): void {
    this.route.paramMap
      .pipe(
        mergeMap((param) => {
          this.dogId = param.get('dogId')!
          this.dogName = param.get('dogName')!

          if (this.dogId) {
            return of(this.dogId)
          } else {
            return throwError(() => 'Nincs kutya azonosító megadva')
          }
        })
      )
      .subscribe(
        () => this.refreshDocuments(),
        (e) => console.error(e)
      )
  }

  ngOnDestroy(): void {}

  refreshDocuments() {
    const dogDoc = doc(this.store, 'dogs', this.dogId)
    getDocs(query(collection(dogDoc, 'documents'), orderBy('documentDate', 'desc'))).then((data: QuerySnapshot<DocumentData>) => {
      this.allDocuments = data.docs.map((d) => {
        const docData = d.data() as DocumentEntry
        return {
          docId: d.id,
          downloadUrl: docData.downloadUrl,
          type: docData.type,
          fileType: docData.fileType || 'application/pdf',
          createdBy: docData.createdBy,
          createdAt: (docData.createdAt as any).toDate(),
          documentDate: (docData.documentDate as any).toDate(),
          idCard: docData.idCard,
        }
      })
    })
  }
}
